import { ace } from '@axo/shared/data-access/types';
import { IAPI } from '../../lib/models/api';

export function createNotification({
  url: { service: baseURL },
  token,
}: IAPI) {
  return async function create(
    req: ace.CreateNotificationReq
  ): Promise<void> {
    const url = new URL('/ace/notifications', baseURL);
    const response = await fetch(url, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify(req),
    });
    if (!response.ok) {
      throw new Error('Failed to create notification');
    }
  };
}

export function readNotification({ url: { service: baseURL }, token }: IAPI) {
  return async function read(id: number): Promise<void> {
    const url = new URL(`/ace/notifications/${id}/read`, baseURL);
    try {
      const response = await fetch(url, {
        method: 'PATCH',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      });
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
    } catch {
      throw new Error('Failed to read notification');
    }
  };
}

export function unreadNotification({ url: { service: baseURL }, token }: IAPI) {
  return async function unread(id: number): Promise<void> {
    const url = new URL(`/ace/notifications/${id}/unread`, baseURL);
    try {
      const response = await fetch(url, {
        method: 'PATCH',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      });
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
    } catch {
      throw new Error('Failed to unread notification');
    }
  };
}

export function getRecentNotifications({
  url: { service: baseURL },
  token,
}: IAPI) {
  return async function getRecentNotifications(
    req: ace.GetRecentNotificationsReq,
  ): Promise<ace.GetRecentNotificationsRes> {
    const url = new URL('/ace/notifications/recent', baseURL);
    for (const [key, value] of Object.entries(req)) {
      url.searchParams.set(key, value);
    }
    try {
      const response = await fetch(url, {
        method: 'GET',
        mode: 'cors',
        headers: {
          Authorization: token,
        },
      });
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    } catch {
      throw new Error('Failed to get recent notifications');
    }
  };
}
